/**
 * How to get a chat export out of WhatsApp, for Android and for iPhone.
 * Step one of the import dialog shows it above the file picker.
 */

import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";

const PLATFORMS = ["android", "ios"] as const;
const STEPS = ["step1", "step2", "step3", "step4"] as const;

export function ImportInstructions(): ReactElement {
	const { t } = useTranslation();
	return (
		<div className="grid gap-3 sm:grid-cols-2">
			{PLATFORMS.map((platform) => (
				<section
					key={platform}
					aria-labelledby={`import-steps-${platform}`}
					className="rounded-lg border border-dashboard-border bg-dashboard-paper p-3"
				>
					<h3
						id={`import-steps-${platform}`}
						className="text-[11px] font-semibold uppercase tracking-wider text-dashboard-muted"
					>
						{t(`realtor.import.instructions.${platform}.title`)}
					</h3>
					<ol className="mt-2 list-decimal space-y-1 pl-4 text-xs text-dashboard-text">
						{STEPS.map((step) => (
							<li key={step}>
								{t(`realtor.import.instructions.${platform}.${step}`)}
							</li>
						))}
					</ol>
				</section>
			))}
		</div>
	);
}
